import { render } from "./WalletExchangeTransfersList.vue?vue&type=template&id=1de91e11&scoped=true"
import script from "./WalletExchangeTransfersList.vue?vue&type=script&lang=js"
export * from "./WalletExchangeTransfersList.vue?vue&type=script&lang=js"

import "./WalletExchangeTransfersList.vue?vue&type=style&index=0&id=1de91e11&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de91e11"]])

export default __exports__